

<div class="panel" style="padding: 1%;">
    <div class="panel--search" *ngIf="!showSearch" [@enterAnimation]>
        <div class="panel__header">
            <a class="button button--primary" style="margin-bottom: 16px;" (click)="showSearchPanel(true)">
                <i class="material-icons button__icon">&#xE8B6;</i>
                <span class="button__text">{{'Search' | translate | async}}</span>
            </a>
            <div class="panel__header__buttons flex-container row">
                <!-- <div *ngFor="let favorite of userFavorites" class="favourites flex-item">
                    <a class="button button--hover-icon" style="background-color: deepskyblue">
                        <span class="button__text" style="color: white"
                            (click)="showFavorite(favorite)">{{favorite.Name}}</span>
                        <i class="material-icons button__icon" style="color: white" matTooltip="Edit Favourite"
                            [matMenuTriggerFor]="menu2">more_vert</i>
                    </a>



                    <mat-menu #menu2="matMenu">
                        <button mat-menu-item (click)="UpdateFavourite(favorite)">
                            <mat-icon>edit</mat-icon>
                            <span>Update Favourite</span>
                        </button>
                        <button mat-menu-item (click)="deleteFavorite(favorite)">
                            <mat-icon>delete_forever</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </div> -->

                <!-- <div class="fav-divider"></div>
                <a class="button" (click)="OpenFavourite()">
                    <i class="material-icons button__icon">favorite</i>
                    <span class="button__text">Create Favourite</span>
                </a> -->
            </div>
        </div>
    </div>

    <div class="panel--search" *ngIf="showSearch" [@enterAnimation]>
        <div class="panel__header">
            <div class="header__title-container" matTooltip="Hide Search" (click)="showSearchPanel(false)"
                style="cursor: pointer;">
                <i class="material-icons title-container__close">close</i>
                <span class="panel__header__title">{{'Search' | translate | async}}</span>
            </div>
            <!-- <div class="panel__header__buttons flex-container row">
                <div *ngFor="let favorite of userFavorites" class="favourites flex-item">
                    <a class="button button--hover-icon" style="background-color: deepskyblue">
                        <span class="button__text" style="color: white"
                            (click)="showFavorite(favorite)">{{favorite.Name}}</span>
                        <i class="material-icons button__icon" style="color: white" matTooltip="Edit Favourite"
                            [matMenuTriggerFor]="menu1">more_vert</i>
                    </a>

                    <mat-menu #menu1="matMenu">
                        <button mat-menu-item (click)="UpdateFavourite(favorite)">
                            <mat-icon>edit</mat-icon>
                            <span>Update Favourite</span>
                        </button>
                        <button mat-menu-item (click)="deleteFavorite(favorite)">
                            <mat-icon>delete_forever</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </div>

                <div style="margin: 8px;">
                    <div class="chkbox">
                        <input class="filled-in" type="checkbox" id="chkHideFavourites" [ngModel]="hideFavourites"
                            (change)="toggleFavourites()" />
                        <label for="chkHideFavourites">Hide Favourites</label>
                    </div>
                </div>

                <div class="fav-divider"></div>
                <a class="button" (click)="OpenFavourite()">
                    <i class="material-icons button__icon">favorite</i>
                    <span class="button__text">Create Favourite</span>
                </a>
            </div> -->
        </div>
        <fecr-search-panel (searchFilters)="getSearchFilters($event)" (selectedTab)="selectedTab"
            (Reset)="ResetFields($event)"></fecr-search-panel>
    </div>




    <div class="panel__content">
        <div>
            <ng-container *ngIf="performSearchImp">
                <ng-container *ngFor="let sP of searchResults">
                    <app-fecr-implment-search-result [searchParameters]="sP"></app-fecr-implment-search-result>
                </ng-container>
            </ng-container>

        </div>
    </div>

</div>

<div class="emptyscreen" *ngIf=" !performSearch ">{{'Please use the Search field above to select what equipment you are shown.' | translate | async}}</div>